import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ApiPostCreatedResponse } from './helpers'
import { httpClient } from './http-client'

export function useCreateTeamContract(teamId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    async mutationFn() {
      return httpClient.post<
        ApiPostCreatedResponse<'/teams/{teamId}/contracts'>
      >(`/teams/${teamId}/contracts`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
    },
  })
}
